document.addEventListener("DOMContentLoaded", function () {
  const content = document.querySelectorAll(".scrollspy__content");
  const scrollspyLinks = document.querySelectorAll(".nav-item");
  const scrollspyNavbar = document.querySelector(".scrollspy-navbar");
  const links = document.querySelectorAll(".nav-link");
  let minHeight = 0;
  let static = 0;
  function smallScreen(e) {
    e.preventDefault();
    const link = this.getAttribute("href");
    if (link) {
      const targetElement = document.querySelector(link);
      if (targetElement) {
        // console.log("targetElement", targetElement.offsetTop);
        const { top } = targetElement.getBoundingClientRect();
        // console.log("props", props);
        // const top = targetElement.offsetTop + 60;
        setTimeout(() => {
          window.scrollTo({
            top: top + window.scrollY - (minHeight + 85),
            behavior: "smooth",
          });
        }, 200);
      }
    }
  }

  function smoothScroll(e) {
    e.preventDefault();
    const link = this.getAttribute("href");
    if (link) {
      const targetElement = document.querySelector(link);
      if (targetElement) {
        const top = targetElement.offsetTop + static;
        setTimeout(() => {
          window.scrollTo({
            top: top,
            behavior: "smooth",
          });
        }, 200);
      }
    }
  }

  let current = "";
  function updateActiveSection() {
    const scrollPos =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    content.forEach((el) => {
      const { top, height } = el.getBoundingClientRect();
      const sectionTop = top + window.scrollY - (minHeight + 200);

      if (scrollPos >= sectionTop && scrollPos < sectionTop + height) {
        current = el.id;
      }
    });

    scrollspyLinks.forEach((li) => {
      li.classList.remove("active");
      if (li.classList.contains(current)) {
        li.classList.add("active");
      }

      if (current === "") {
        scrollspyLinks[0].classList.add("active");
      }
    });
  }

  function setMinHeight() {
    minHeight = scrollspyNavbar?.clientHeight;

    if (window.innerWidth >= 992) {
      if (links.length) {
        links.forEach((elem) => {
          elem.addEventListener("click", smallScreen);
        });
      }
    } else {
      if (links.length) {
        links.forEach((elem) => {
          elem.addEventListener("click", smoothScroll);
        });
      }
    }

    if (window.innerWidth >= 992) {
      static = 58;
    } else if (window.innerWidth >= 668) {
      static = 18;
    } else {
      static = 58;
    }
  }

  window.addEventListener("resize", setMinHeight);
  window.addEventListener("scroll", updateActiveSection);

  // Initial call to set minHeight on page load
  setMinHeight();
});
